import React from "react";
import {NavLink} from "react-router-dom";

export interface NavigationLinkProps {
    to: string
    unsavedDataProtection?: boolean
    onClick: () => void
    children: React.ReactNode | React.ReactNode[]
}

export function NavigationLink({to, unsavedDataProtection , onClick, children }: NavigationLinkProps) {


    if( unsavedDataProtection ) {
        return (
            <div onClick={ onClick }>
                { children }
            </div>
        );
    } else {
        return (
            <NavLink to={ to } onClick={ onClick } >
                { children }
            </NavLink>
        );
    }
}